<h1 class="mb-2 tp-hed">Response on Affinity Questions</h1>
<!-- <div style="overflow-y: auto; min-height: 400px;">  -->
<ng-container *ngFor="let tooltipData of universityAffinityQuestion">

  
    <div *ngIf="tooltipData.AffinityQuestionSelectedOption != ''" >
      <div class="text-lg font">{{ tooltipData.label }}</div>
      <p>Answer :- <strong>{{firstLetterUpper( tooltipData.AffinityQuestionSelectedOption) }}</strong></p>
      <div *ngIf="tooltipData.eligibility != ''">
        <strong> Eligibility</strong>
        <p class="point" *ngFor="let points of getEligibilityPoints(tooltipData.eligibility)">{{ points }}</p>
      </div>
      <div *ngIf="tooltipData.terms != ''">
        <strong>Terms & Condition</strong>
        <p class="point" *ngFor="let points of getTersandConditionPoints(tooltipData.terms)">{{ points }}</p>
  
      </div>
    
  </div>


</ng-container>  
<!-- </div> -->
<div class="text-center mt-2 pt-4 border-top">
  <button class="page-btn" (click)="close()">Close</button>
</div>
